import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../views/Home";
import Contact from "../views/Contact";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("../views/Detail"),
  },
  {
    path: "/more",
    name: "more",
    component: () => import("../views/More"),
  },
  {
    path: "/contact-us",
    name: "contact",
    component: Contact,
  },
  {
    path: "/association-overview",
    name: "association-overview",
    component: () => import("../views/ListPage"),
  },
  {
    path: "/association-news",
    name: "association-news",
    component: () => import("../views/ListPage"),
  },
  {
    path: "/quality-safety",
    name: "quality-safety",
    component: () => import("../views/ListPage"),
  },
  {
    path: "/file-link",
    name: "file-link",
    component: () => import("../views/ListPage"),
  },
  {
    path: "/party-building",
    name: "party-building",
    component: () => import("../views/ListPage"),
  },
  {
    path: "/member-style",
    name: "member-style",
    component: () => import("../views/ListPage"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.state.menuState.menu.length) {
    let menuArray = [...store.state.menuState.menu];
    for (let i = 0; i < menuArray.length; i++) {
      if (to.path === menuArray[i].href) {
        menuArray[i].active = true;
      } else {
        if (to.path !== "/detail" && to.path !== "/more") {
          menuArray[i].active = false;
        }
      }
    }
    store.commit("menuState/setMenu", menuArray);
  }
  next();
});

export default router;
